import React, { useEffect, useState, useRef } from "react";
import { initializeGame } from "./game";
import Stats from "./components/Stats";
import EndMessage from "./components/EndMessage";
import Drops from "./components/Drops";
import { getEnemyNames } from "./utils/tiledReader";
import { STARTING_LEVEL, enemyRecord } from "./data/settings";

const enemies = getEnemyNames();
const getHP = (level: number) =>
  Math.floor(enemyRecord[enemies[level]].hp + level ** 1.1);
const MAX_FORTRESS_HP = 100;

export default function App() {
  const gameRef = useRef<Phaser.Game>();
  const [level, setLevel] = useState(STARTING_LEVEL - 1);

  const [hp, setHP] = useState(MAX_FORTRESS_HP);
  const [enemyHP, setEnemyHP] = useState(getHP(level));
  // prettier-ignore
  const [enemyMaxHP,setEnemyMaxHP] = useState(getHP(level));

  const [drops, setDrops] = useState<Record<string, number>>({});

  // initialize game
  useEffect(() => {
    const setters = { hp: setHP, drops: setDrops, enemy: setEnemyHP };
    gameRef.current = initializeGame(setters);
  }, []);

  // once HP reaches zero, go to EndScene
  useEffect(() => {
    if (hp <= 0) {
      gameRef.current?.scene.stop("Game");
      gameRef.current?.scene.start("End");
    }
  }, [hp]);

  // once enemy's HP reaches zero, go to next level
  useEffect(() => {
    if (enemyHP <= 0) {
      if (level + 1 >= enemies.length) {
        gameRef.current?.scene.stop("Game");
        gameRef.current?.scene.start("End");
      } else {
        setLevel(level + 1);
        setEnemyHP(getHP(level + 1));
        setEnemyMaxHP(getHP(level + 1));
        gameRef.current?.scene.scenes[0].populateLevel(level + 2);
      }
    }
  }, [enemyHP, level]);
  const lastEnemyDefeated = enemyHP <= 0 && level === enemies.length - 1;
  return hp > 0 && !lastEnemyDefeated ? (
    <div id="ui-game-scene">
      <p style={{ position: "absolute", top: "2rem" }}>Level {level + 1}</p>
      <div className="stats-container">
        <Stats value={hp} label="Fortress" />
        <Stats value={enemyHP} max={enemyMaxHP} label={enemies[level]} />
      </div>
      <Drops drops={drops} />
    </div>
  ) : (
    <EndMessage won={lastEnemyDefeated} />
  );
}
